import DataTable from 'react-data-table-component';

import StyledTable from './styles';

import useTableData from './useTableData';

const InfoTable = ({ distributionAllocationType }) => {
    const {
        data,
    } = useTableData(distributionAllocationType);

    return (
        <StyledTable>
            <div className="tableContainer">
                <DataTable
                    columns={data.columns}
                    data={data.rows}
                    dense
                />
            </div>
        </StyledTable>
    );
};

export default InfoTable;
